import { MatPaginatorIntl } from '@angular/material/paginator';

export function spanishPaginator(): MatPaginatorIntl {
  const intl = new MatPaginatorIntl();
  intl.itemsPerPageLabel = 'Por página';
  intl.nextPageLabel = 'Siguiente';
  intl.previousPageLabel = 'Anterior';
  intl.firstPageLabel = 'Primera';
  intl.lastPageLabel = 'Última';
  intl.getRangeLabel = (page, size, length) => {
    if (!length) return '0 de 0';
    const start = page * size;
    return `${start + 1}–${Math.min(start + size, length)} de ${length}`;
  };
  return intl;
}
